export const SLIDE_BACKGROUND_COLOR = 'color';
export const SLIDE_BACKGROUND_IMAGE = 'image';
export const SLIDE_BACKGROUND_VIDEO = 'video';
